import axios from "axios";

import configData from "../../config/config.json";

export const AlertListComponetName = "AlertList";
export const AlertListTenantAdminComponetName = "AlertListTenantAdmin";

export const saveAlert = (alert, callback) => async dispatch => {

  await axios.post(configData.LANDNOTIFICATION_SERVER_URL + "controlPanel/alert", alert, { withCredentials: true })
    .then((response) => {
      dispatch({ type: 'LANDNOTIFICATION_ALERTS', results: response.data.content });
      callback(true, false, response.data.message);
    }, (error) => {
      callback(false, true, error.response.data.message);
    });
};

export const saveTenantAlert = (alert, callback) => async dispatch => {

  await axios.post(configData.LANDNOTIFICATION_SERVER_URL + "tenantAdmin/alert", alert, { withCredentials: true })
    .then((response) => {
      dispatch({ type: 'LANDNOTIFICATION_ALERTS', results: response.data.content });
      callback(true, false, response.data.message);
    }, (error) => {
      callback(false, true, error.response.data.message);
    });
};

export const saveUserViewAlert = (alert, callback) => async dispatch => {

  await axios.post(configData.LANDNOTIFICATION_SERVER_URL + "userView/alert", alert, { withCredentials: true })
    .then((response) => {
      dispatch({ type: 'LANDNOTIFICATION_ALERTS', results: response.data.content });
      callback(true, false, response.data.message);
    }, (error) => {
      callback(false, true, error.response.data.message);
    });
};

export const lookupAlert = (id, callback) => async dispatch => {
  await axios.get(configData.LANDNOTIFICATION_SERVER_URL + "userView/alert/" + id, { withCredentials: true })
    .then(
      (response) => {
        dispatch({ type: 'SET_SELECTED_ALERT', results: response.data.content });
        callback(response.data.message);
      },
      (error) => {
        callback(error.response.data.message);
        console.log(error);
      }
    );
};